import { createSlice } from '@reduxjs/toolkit';
const customer: any = {};
const beneficiary: any = {};
const transaction: any = {};
const filters: any = {};

const customerMerchantAccount: any = {};
export const initialState = {
	isLoading: false,
	customer,
	success: false,
	error: undefined,
	customers: [],
	transactions: [],
	beneficiaries: [],
	beneficiary,
	transaction,
	customerMerchantAccount,
	customerMerchantAccounts: [],
	filters,
};
const customerManagementSlice = createSlice({
	name: 'customerManagement',
	initialState,
	reducers: {
		setCustomerIsLoading: (state) => {
			state.isLoading = true;
		},

		setCustomer: (state, action) => {
			state.customer = action.payload;
		},

		setCustomers: (state, action) => {
			state.customers = action.payload;
		},
		setCustomerBeneficiaries: (state, action) => {
			state.beneficiaries = action.payload;
		},
		setCustomerMerchantAccount: (state, action) => {
			state.customerMerchantAccount = action.payload;
		},
		setCustomerTransactions: (state, action) => {
			state.transactions = action.payload;
		},

		resetCustomerTransactions: (state) => {
			state.transactions = [];
		},
		setCustomerTransaction: (state, action) => {
			state.transaction = action.payload;
		},

		resetCustomerTransaction: (state) => {
			state.transaction = {};
		},
		resetCustomerMerchantAccount: (state) => {
			state.customerMerchantAccount = {};
		},
		resetCustomerBeneficiaries: (state) => {
			state.beneficiaries = [];
		},
		setCustomerBeneficiary: (state, action) => {
			state.beneficiary = action.payload;
		},
		resetCustomerBeneficiary: (state) => {
			state.beneficiary = {};
		},
		resetCustomerSucess: (state) => {
			state.success = false;
		},
		resetCustomer: (state) => {
			state.customer = {};
		},
		resetCustomerIsLoading: (state) => {
			state.isLoading = false;
		},
		setCustomerFilters: (state, action) => {
			state.filters = action.payload;
		},
		resetCustomerFilters: (state) => {
			state.filters = {};
		},
		resetCustomerManagement: (state) => {
			state.customer = {};
			state.customers = [];
			state.error = undefined;
			state.isLoading = false;
			state.success;
		},
		setCustomerMerchantAccounts: (state, action) => {
			state.customerMerchantAccounts = action.payload;
		},
		resetCustomerMerchantAccounts: (state) => {
			state.customerMerchantAccounts = [];
		},
	},
});

export const {
	setCustomer,
	resetCustomer,
	setCustomerIsLoading,
	setCustomers,
	resetCustomerManagement,
	resetCustomerSucess,
	resetCustomerIsLoading,
	setCustomerBeneficiaries,
	setCustomerBeneficiary,
	resetCustomerBeneficiaries,
	resetCustomerBeneficiary,
	setCustomerMerchantAccount,
	setCustomerMerchantAccounts,
	setCustomerTransactions,
	resetCustomerTransactions,
	setCustomerTransaction,
	resetCustomerTransaction,
	setCustomerFilters,
	resetCustomerFilters,
	resetCustomerMerchantAccount,
	resetCustomerMerchantAccounts,
} = customerManagementSlice.actions;

export default customerManagementSlice.reducer;
